export default __webpack_public_path__ + "7304456c8e5da0a6364fc2141b846984.woff2";